import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from 'gatsby-image'
import { Link } from 'gatsby'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import './style.scss'

const POSTS = [
	{
		title: 'Master’s in Applied Behavior Analysis (MABA)',
		excerpt: '<p>The Master’s in Applied Behavior Analysis is a comprehensive graduate program designed to prepare students for careers as skilled practitioners, researchers, and leaders in the field of applied behavior analysis (ABA). This program combines theoretical foundations with practical applications, focusing on the scientific study of human and animal behavior to solve real-world problems across diverse settings. </p>',
		uri: '/archives/academic/master-of-behavior-analysis/',
		image: 'mru-news-0.jpg',
		categories: ['Programs'],
	},
	{
		title: 'MRU Introduced the Bachelor of Science in Applied Behavior Analysis (BS-ABA)',
		excerpt: '<p>The behavior analysis program at Miami Regional University offers training to undergraduate students in the scientific study of human and other animal behavior to teach the basic concepts and principles of behavior analysis. Students will learn to analyze how behavior changes when interacting with the surrounding environment. </p>',
		uri: '/archives/academic/bachelor-of-science-in-applied-behavior-analysis-bs-aba/',
		image: 'mru-news-1.jpg',
		categories: ['Programs'],
	},
	{
		title: 'MRU Welcomes International Students',
		excerpt: '<p>Miami Regional University (MRU) has received SEVP approval to enroll international students. On September 2, 2024, MRU welcomed its first cohort of international students.</p>',
		uri: '/international-students/',
		image: 'mru-news-2.jpg',
		categories: ['Programs'],

	},
	{
		title: 'MRU expands its educational horizon by introducing Post-Master Certifications in Adult-Gerontology Acute Care and Psychiatric Mental Health',
		excerpt: '<p>Miami Regional University (MRU) is proud to announce the introduction of Post-Master Certifications in Adult-Gerontology Acute Care and Psychiatric Mental Health. These new programs are designed for advanced practice nurses looking to enhance their expertise and expand their career opportunities in critical healthcare areas. With an increasing demand for specialized care, MRU aims to equip […]</p>',
		uri: '/nursing/',
		image: 'mru-news-3.jpg',
		categories: ['Programs'],

	},
	// {
	// 	title: 'MRU Expands Graduate Offerings with New Master’s in Behavior Analysis',
	// 	excerpt: "<p>The Master's in Applied Behavior Analysis program aims to prepare skilled and ethical behavior analysts capable of addressing complex behavioral challenges. Through a blend of theoretical knowledge, practical application, and research, graduates will design effective interventions, promote positive behavior change, and lead in diverse settings while adhering to professional and ethical standards.</p>",
	// 	uri: '/archives/academic/master-of-behavior-analysis/',
	// 	image: 'mru-news-4.jpg',
	// 	categories: ['Programs'],
	// },
	// {
	//   title: 'New Bachelor of Business & Healthcare Management Program Launches at MRU',
	//   excerpt: '<p>The Bachelor of Science degree in Business and Healthcare Management is designed to provide students with a comprehensive foundation of the principles and practices required within the dynamic and evolving business enterprise. Closer attention is given to one of the fastest-growing segments of business, which is the healthcare industry. Students will develop their business acumen and improve upon leadership, decision-making, critical-thinking, and problem-solving skills needed in business at large and particularly, in the healthcare industry.</p>',
	//   uri: '#',
	//   image: 'mru-news-5.jpg',
	//   categories: ['Programs'],
	// },
]

function CustomBlock() {
	const { allFile } = useStaticQuery(graphql`
    query MruNewsImages {
      allFile(
        filter: {
          sourceInstanceName: { eq: "images" }
          relativePath: { in: ["mru-news-0.jpg", "mru-news-1.jpg", "mru-news-2.jpg", "mru-news-3.jpg", "mru-news-4.jpg"] }
        }
      ) {
        nodes {
          relativePath
          childImageSharp {
            fluid(maxWidth: 800, quality: 80) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    }
  `)

	const imageMap = (allFile?.nodes ?? []).reduce((acc, node) => {
		if (node?.childImageSharp?.fluid) {
			acc[node.relativePath] = node.childImageSharp.fluid
		}
		return acc
	}, {})

	const sliderSettings = {
		dots: false,
		arrows: true,
		infinite: POSTS.length > 3,
		speed: 500,
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					infinite: true
				},
			},

		],
	}

	const slides = POSTS.map((post, i) => {
		const fluid = imageMap[post.image]
		return (
			<div key={i} className={`mru-news-slide `}>
				<article className={`single-post animated from-top-subtle delay-${i * 2}`}>
					<div className="wrap">
						<div className="box">
							<p className="categories h6">
								{post.categories.join(' / ')}
							</p>
							<h3>
								<Link to={post.uri}>{post.title}</Link>
							</h3>
							<div className="excerpt" dangerouslySetInnerHTML={{ __html: post.excerpt }} />
						</div>
						<div className="img-container">
							<p className="link">
								<Link to={post.uri}>LEARN MORE</Link>
							</p>
							<div className="img-wrapper">
								<Link to={post.uri} title={post.title}>
									{fluid ? (
										<Img
											fluid={fluid}
											alt={post.title}
											imgStyle={{ objectFit: 'cover' }}
										/>
									) : (
										<div className="img-placeholder" aria-hidden="true" />
									)}
								</Link>
							</div>
						</div>
					</div>
				</article>
			</div>
		)
	})

	return (
		<div className="grid-12 mru-news-block">
			<div className="span-12 mru-news-slider-wrapper">
				<Slider {...sliderSettings} className="mru-news-slider">
					{slides}
				</Slider>
			</div>

		</div>
	)
}

export default CustomBlock
